import * as React from 'react';
var ResizeContext = /*#__PURE__*/React.createContext(null);
export default ResizeContext;